// ============================================================
// Domain — Date / time arithmetic and display formatting
// ============================================================

import moment from 'moment';

// Calendar-day buffer ShopBack typically needs to review + set up a campaign.
// Used to prefill the start date as a friendly default and to drive the
// soft buffer hint shown when the merchant picks an earlier date.
export const LEAD_TIME_DAYS = 5;

export const todayPlus = (days: number): Date => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + days);
  return d;
};

// Combine a date + HH:mm string into a single moment — same combination the
// submit mapper uses (wizardMappers.toIsoDatetime), so the ordering we validate
// matches the ordering we POST.
export const combineDateAndTime = (date: Date, time: string): moment.Moment => {
  const [h, min] = (time || '').split(':').map(Number);
  return moment(date)
    .hour(h || 0)
    .minute(min || 0)
    .second(0)
    .millisecond(0);
};

/** Core start→end check at full datetime granularity (date + time). Equal is allowed. */
export const isEndBeforeStart = (startDate: Date, startTime: string, endDate: Date, endTime: string): boolean =>
  combineDateAndTime(endDate, endTime).isBefore(combineDateAndTime(startDate, startTime));

export const fmtMonthDay = (d: Date | null): string =>
  d ? d.toLocaleDateString('en-SG', { day: '2-digit', month: 'short' }) : '—';

export const fmtFull = (d: Date | null): string =>
  d ? d.toLocaleDateString('en-SG', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
